export const PACKAGES = [
  {
    key: "launch",
    icon: "Leaf",
    name: "Launch",
    price: "$200",
    cadence: "/month",
    tagline: "New businesses that need a start-up presence.",
    featured: false,
    features: [
      "Marketing Strategizing Session",
      "Social Media Management (2 platforms)",
      "8 Custom Posts",
      "Basic Graphic Design",
      "Monthly Content Calendar",
      "End of Month Consultation",
    ],
  },
  {
    key: "growth",
    icon: "TrendUp",
    name: "Growth",
    price: "$450",
    cadence: "/month",
    tagline: "Increase awareness & customer engagement.",
    featured: false,
    features: [
      "Marketing Strategy Session",
      "Social Media Management (3 platforms)",
      "16 Custom Posts",
      "6 Short-Form Content",
      "Graphic Design",
      "Monthly Strategy Meeting",
      "SMS Campaign (1 blast/month)",
      "Monthly Analytics Support",
      "Basic Support",
    ],
  },
  {
    key: "momentum",
    icon: "Rocket",
    name: "Momentum",
    price: "$600",
    cadence: "/month",
    tagline: "Businesses actively investing in growth.",
    featured: true,
    features: [
      "Marketing Strategizing Session",
      "Social Media Management (4 platforms)",
      "20–24 Custom Posts",
      "8 Edited Videos",
      "Photography Session",
      "2 SMS Campaigns",
      "Monthly Marketing Strategy Review",
      "Competitor Analysis",
      "Quarterly Marketing Map",
    ],
  },
  {
    key: "elite",
    icon: "Crown",
    name: "Elite",
    price: "$800",
    cadence: "/month",
    tagline: "A complete outsourced marketing team.",
    featured: false,
    features: [
      "Marketing Strategy Consultation",
      "Social Media Management (4 platforms)",
      "28 Posts Monthly",
      "10 Edited Promo Videos",
      "2 Photography Sessions",
      "4 SMS Campaigns",
      "Unlimited Strategy Meetings & Design Requests",
      "Full Brand Management",
      "Community Pop-Ups",
      "Campaign Planning",
      "Monthly Executive Report",
      "High Priority Support",
    ],
  },
];

export const INDIVIDUAL_SERVICES = [
  ["Social Media Management", "$250/month"],
  ["Content Creation", "$200/month"],
  ["Graphic Design", "$75/project"],
  ["Logo Design", "$75"],
  ["Website Design", "$900"],
  ["Marketing Strategy Session", "$20"],
  ["Photography", "$250/session"],
  ["Videography with Video Editing", "$300–400/session"],
  ["SMS Marketing Campaign", "$75/campaign"],
];

export const ADDONS = [
  ["Additional Social Platform", "$100/month"],
  ["Additional 4 Posts", "$75/month"],
  ["Additional Reel", "$30 each"],
  ["Extra Photography Session", "$250"],
  ["Additional SMS Campaign", "$75"],
];

export const MANIFESTO = [
  { n: "01", word: "Passion", text: "Everything starts with genuine passion for your brand. We take the time to understand your story, your market and your goals before a single post is designed." },
  { n: "02", word: "Produce", text: "From graphic design to short-form video and professional photography, we craft content that looks the way your brand deserves to be seen." },
  { n: "03", word: "Promote", text: "We put your content to work across social platforms and SMS campaigns, engineered to grow awareness and customer engagement." },
  { n: "04", word: "Profit", text: "Monthly performance and executive reporting keep everything accountable to the one metric that matters — your growth." },
];

export const IMAGES = {
  logo: `${process.env.PUBLIC_URL || ""}/logo-4ps.png`,
  hero: "https://images.unsplash.com/photo-1497215842964-222b430dc094?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwbWFya2V0aW5nJTIwb2ZmaWNlfGVufDB8fHx8MTc4NDA3MzMxNnww&ixlib=rb-4.1.0&q=85",
  photography: "https://images.unsplash.com/photo-1471341971476-ae15ff5dd4ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBwaG90b2dyYXBoeSUyMHN0dWRpb3xlbnwwfHx8fDE3ODQwNzMzMTZ8MA&ixlib=rb-4.1.0&q=85",
  social: "https://images.unsplash.com/photo-1724862936518-ae7fcfc052c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxzb2NpYWwlMjBtZWRpYSUyMG1hcmtldGluZyUyMGNvbnRlbnQlMjBjcmVhdGlvbnxlbnwwfHx8fDE3ODQwNzMzMjl8MA&ixlib=rb-4.1.0&q=85",
};

export const CONTACT = {
  email: "4ps.marketing.group.4@gmail.com",
  tiktok: "4ps.marketing.group",
  instagram: "4ps.marketing.group",
};

export const INTRO = "Two young founders. Three years deep in marketing — catching trends before they peak and building brands with real passion.";

export const TEAM = [
  {
    name: "Taij Persaud",
    initials: "TP",
    age: "17",
    role: "Finance & Marketing Student",
    photo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_marketing-momentum-11/artifacts/4c1z2e70_IMG_3507.webp",
    objectPosition: "center 20%",
    bio: "A 17-year-old finance and marketing student driven by data and design. Taij blends numbers with narrative — building strategies that don't just look good, but actually move the needle for local businesses.",
  },
  {
    name: "Abbie Mercado",
    initials: "AM",
    age: "17",
    role: "Finance & Marketing Student",
    photo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_marketing-momentum-11/artifacts/23ggdync_DSC07634.webp",
    objectPosition: "center 78%",
    bio: "A 17-year-old finance and marketing student with an eye for brand and community. Abbie turns everyday businesses into stories people want to follow, share and support.",
  },
];

export const TEAM_STATEMENT = "Finance and marketing aren't just subjects we study — they're how we think. We started 4PS to prove that fresh, ambitious minds can deliver serious results. Our goal is simple: help the businesses in our community grow with strategy that's honest, creative content that connects, and marketing that turns attention into profit.";

export const PORTFOLIO_CATEGORIES = ["All", "Social Media", "Graphic Design", "Video", "Photography", "Branding", "Campaign"];
